import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看更多',
  icon,
  children,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2 font-heading font-bold text-xl md:text-2xl text-foreground-950">
          {icon && (
            <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
              <i className={`${icon} text-lg`}></i>
            </span>
          )}
          <span className="truncate">{title}</span>
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {children}
      {moreTo && !children && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}